import { Box as MUIBox } from '@mui/material';

const Box = MUIBox;

export default Box;
